// import React from 'react';
import Dexie from 'dexie';

const db = new Dexie("SoundfilesDatabase");

db.version(1).stores({ soundfiles: "title,file" })
// db.open().catch((err) => { console.log(err.stack || err) })
db.soundfiles.clear().then().catch();

export default db;